// extracted by mini-css-extract-plugin
export default {"errorBox":"FailureDetail_errorBox__qJBf9","codeBlock":"FailureDetail_codeBlock__NiOQ3","codeBlockNowrap":"FailureDetail_codeBlockNowrap__czGwy"};